// extracted by mini-css-extract-plugin
export var BlogCard = "BlogCard-module--BlogCard--24400";
export var bottomContainer = "BlogCard-module--bottomContainer--f6173";
export var dateContainer = "BlogCard-module--dateContainer--85b64";
export var summary = "BlogCard-module--summary--fcbda";
export var titleContainer = "BlogCard-module--titleContainer--d2513";
export var topContainer = "BlogCard-module--topContainer--52ee8";